/**
 * isartau — Lightbox als Carousel-Ansicht (Etappe 2)
 * ---------------------------------------------------------------------------
 * Baut Dawns vorhandene Lightbox zu einer Carousel-Ansicht um: eine Buehne,
 * eine Thumbnail-Leiste, Pfeile, Tastatur, Wischen. Optik und die gemessene
 * Shopware-Referenz stehen in snippets/galerie-lightbox-styles.liquid.
 *
 * WAS DAWN SCHON MITBRINGT — und deshalb hier NICHT gebaut wird:
 *   Oeffnen             <modal-opener> ruft modal.show(button)
 *   Startbild           product-modal.js liest openedBy.dataset.mediaId
 *   Schliessen (X)      ModalDialog bindet [id^="ModalClose-"]
 *   Schliessen (Escape) ModalDialog hoert auf keyup
 *   Fokusfalle          trapFocus beim Oeffnen, Rueckgabe an openedBy
 *   Filterung           Rubik filtert die Modal-Kinder bereits
 *
 * ⚠️ ZWEI FALLEN IN DAWN, die hier abgefangen werden:
 *
 *   1. ModalDialog schliesst bei JEDEM pointerup mit der Maus im Modal
 *      (assets/global.js: "if (event.pointerType === 'mouse' && !event.target
 *      .closest('deferred-media, product-model')) this.hide()"). Ein Klick auf
 *      Pfeil oder Thumbnail wuerde die Lightbox also schliessen. Alle eigenen
 *      Bedienelemente stoppen deshalb die Weitergabe von pointerup.
 *
 *   2. product-modal.js greift beim Oeffnen auf
 *      openedBy.getAttribute('data-media-id') zu und wuerde ohne gueltigen
 *      Wert an activeMedia.querySelector scheitern. Der Knopf "weitere Bilder"
 *      bekommt deshalb VOR dem Oeffnen die Media-ID des ersten sichtbaren
 *      Mediums gesetzt.
 *
 * SCHLIESSEN, BLAETTERN, VIDEO (Phase 1, Auftrag 12.10.2026):
 *
 *   Schliessen NUR ueber X, Escape und Browser-Zurueck. Klicks auf Bild,
 *   Video oder weisse Flaeche schliessen nie — Dawns pointerup-Schliessen
 *   (Falle 1) wird deshalb am Dialog vollstaendig abgefangen, nicht mehr nur
 *   an einzelnen Knoepfen.
 *
 *   Browser-Zurueck: Beim Oeffnen wird ein Historie-Eintrag gesetzt. Zurueck
 *   nimmt ihn weg und schliesst nur die Lightbox. Schliessen per X/Escape
 *   nimmt ihn selbst wieder heraus (history.back), damit kein Leer-Eintrag
 *   zurueckbleibt.
 *
 *   Desktop: linke Haelfte der Flaeche neben dem Medium = zurueck, rechte =
 *   weiter, ueber die volle Hoehe. Nur mit feinem Zeiger (Maus) — auf dem
 *   Handy wird gewischt, ein Tipp daneben soll dort nichts ausloesen.
 *
 *   Video: Dawn legt Videos als <deferred-media> mit Vorschaubild an und baut
 *   das <video> erst beim Klick — stumm und mit Autoplay. Hier wird es selbst
 *   aus Dawns <template> erzeugt, sobald das Video auf der Buehne steht: mit
 *   Steuerelementen, OHNE Autoplay, NICHT stumm. Start nur ueber Play.
 *
 *   Fokusfalle: Dawns trapFocus merkt sich erstes/letztes Element beim
 *   Oeffnen. Die Leiste wird danach neu gebaut, das gemerkte letzte Element
 *   ist dann ein geloeschter Knopf — Tab liefe aus der Lightbox hinaus.
 *   Deshalb eine eigene Falle, die bei jedem Tab neu zaehlt.
 *
 * Eingebunden ueber snippets/galerie-lightbox.liquid, aufgerufen aus
 * sections/main-product.liquid. Keine Dawn-Datei veraendert.
 */
(function () {
  'use strict';

  /* Wegschwelle in Pixeln, ab der eine Beruehrung als Wischen gilt.
     10 px entspricht der Toleranz, mit der Browser selbst einen Tap von einer
     Bewegung trennen (Chromiums "touch slop"). Darunter wird der Finger beim
     Antippen praktisch immer bleiben. */
  var TAP_WEG_PX = 10;

  /* Hoechstdauer einer Beruehrung, die noch als Tap zaehlt. 500 ms liegt
     unter der ueblichen Schwelle fuer ein langes Druecken und ueber dem, was
     ein normaler Tap braucht. */
  var TAP_DAUER_MS = 500;

  /* Ab dieser Aenderung der Scrollposition waehrend der Beruehrung gilt die
     Geste sicher als Wischen. Das ist das HAERTERE Signal als der Weg: Wenn
     der Slider gescrollt hat, war es kein Tap — unabhaengig davon, wie weit
     der Finger gekommen ist. */
  var TAP_SCROLL_PX = 2;

  /* Hoehe der Steuerleiste des Videos, gemessen von dessen Unterkante. Ein
     Wisch, der dort beginnt, blaettert NICHT — sonst wuerde jedes Spulen auf
     dem Handy zum naechsten Bild springen. 56 px deckt die Leiste von Chrome
     und Safari samt Fingertoleranz ab. */
  var VIDEO_STEUERLEISTE_PX = 56;

  /* Markierung des eigenen Historie-Eintrags. Nur ein Eintrag mit genau
     dieser Markierung wird beim Schliessen wieder herausgenommen. */
  var HISTORIE_MARKE = 'isartauGalerieLightbox';

  /* Blaettern ueber die Flaeche neben dem Medium nur mit Maus/Trackpad. */
  var FEINER_ZEIGER = window.matchMedia('(hover: hover) and (pointer: fine)');

  var DEBUG = false;

  function log() {
    if (!DEBUG) return;
    var a = Array.prototype.slice.call(arguments);
    a.unshift('[galerie-lightbox]');
    console.log.apply(console, a);
  }

  if (window.__isartauGalerieLightbox) return;
  window.__isartauGalerieLightbox = true;

  /* =========================================================================
   * Kleinkram
   * ======================================================================= */

  /** Sichtbar heisst: von Rubik nicht per Inline-Style ausgeblendet. */
  function istSichtbar(el) {
    return (el.getAttribute('style') || '').indexOf('display: none') === -1;
  }

  function medien(modal) {
    var inhalt = modal.querySelector('.product-media-modal__content');
    if (!inhalt) return [];
    return Array.prototype.filter.call(inhalt.children, function (el) {
      return el.hasAttribute('data-media-id') && istSichtbar(el);
    });
  }

  /** pointerup nicht bis zum Modal durchlassen — sonst schliesst es sich. */
  function klickSchuetzen(el) {
    el.addEventListener('pointerup', function (e) {
      e.stopPropagation();
    });
  }

  /* =========================================================================
   * Video
   * ======================================================================= */

  /** Dawns Video-Huelle mit einem Shopify-Video (nicht YouTube/Vimeo). */
  function videoVorlage(el) {
    if (!el || el.tagName !== 'DEFERRED-MEDIA') return null;
    var vorlage = el.querySelector('template');
    return vorlage ? vorlage.content.querySelector('video') : null;
  }

  /**
   * Das <video> selbst erzeugen, sobald das Medium auf der Buehne steht.
   * Einmal je Huelle; das Attribut "loaded" sagt Dawns DeferredMedia, dass
   * nichts mehr nachzuladen ist — sein Vorschaubild-Klick laeuft dann leer.
   */
  function videoVorbereiten(el) {
    var vorlage = videoVorlage(el);
    if (!vorlage || el.querySelector(':scope > video')) return;

    var video = vorlage.cloneNode(true);
    /* Shopifys media_tag setzt bei autoplay zwingend auch muted. Beides
       muss weg: kein Autoplay, und Ton an, sobald jemand Play drueckt. */
    video.removeAttribute('autoplay');
    video.removeAttribute('muted');
    video.autoplay = false;
    video.muted = false;
    video.defaultMuted = false;
    video.controls = true;
    video.setAttribute('playsinline', '');
    /* Nur Laenge und erstes Bild laden, nicht das ganze Video. */
    video.setAttribute('preload', 'metadata');

    /* Seitenverhaeltnis aus Dawns Vorschaubild (width/height stehen dort im
       Markup). Damit hat das Video seine Groesse sofort, nicht erst, wenn
       die Metadaten da sind — sonst sprang es von 300 x 150 auf die echte
       Groesse. */
    var poster = el.querySelector('.deferred-media__poster img');
    var b = poster ? parseFloat(poster.getAttribute('width')) : 0;
    var h = poster ? parseFloat(poster.getAttribute('height')) : 0;
    if (b > 0 && h > 0) video.style.setProperty('--galerie-lb-video-verhaeltnis', String(b / h));

    el.appendChild(video);
    el.setAttribute('loaded', 'true');
    log('Video vorbereitet', el.getAttribute('data-media-id'));
  }

  function videosAnhalten() {
    if (!z) return;
    Array.prototype.forEach.call(z.modal.querySelectorAll('video'), function (v) {
      if (!v.paused) v.pause();
    });
  }

  /* =========================================================================
   * Zustand
   * ======================================================================= */

  var z = null;

  function aktivesMedium() {
    var inhalt = z.modal.querySelector('.product-media-modal__content');
    return inhalt ? inhalt.querySelector('.active') : null;
  }

  function aktiverIndex(liste) {
    var a = aktivesMedium();
    if (!a) return 0;
    var i = liste.indexOf(a);
    return i < 0 ? 0 : i;
  }

  /**
   * Buehne auf ein Medium setzen. Bewusst dieselbe Mechanik wie
   * product-modal.js: die Klasse "active" entscheidet, das Stylesheet blendet
   * alles andere aus.
   */
  function zeigen(index) {
    var liste = medien(z.modal);
    if (!liste.length) return;
    if (index < 0) index = 0;
    if (index > liste.length - 1) index = liste.length - 1;

    /* Ein laufendes Video haelt beim Blaettern an. */
    videosAnhalten();

    var inhalt = z.modal.querySelector('.product-media-modal__content');
    Array.prototype.forEach.call(inhalt.children, function (el) {
      el.classList.remove('active');
    });
    liste[index].classList.add('active');
    videoVorbereiten(liste[index]);

    zustandZeichnen(liste, index);
  }

  /**
   * Nach einem Inhaltsaustausch dafuer sorgen, dass ueberhaupt ein Medium
   * aktiv ist — sonst bleibt die Buehne leer.
   *
   * Bevorzugt dasselbe Bild wie vorher, sofern es die neue Variante auch
   * zeigt. Sonst das erste sichtbare. Ist die Lightbox zu, passiert nichts:
   * Dawn setzt beim naechsten Oeffnen ohnehin selbst.
   */
  function aktivSicherstellen() {
    if (!z || !z.modal.hasAttribute('open')) return;
    var liste = medien(z.modal);
    if (!liste.length) return;

    var aktiv = aktivesMedium();
    if (aktiv && liste.indexOf(aktiv) >= 0) return;

    var index = 0;
    if (z.letzteId) {
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].getAttribute('data-media-id') === z.letzteId) {
          index = i;
          break;
        }
      }
    }
    zeigen(index);
    log('Buehne nach Inhaltsaustausch neu gesetzt, Index', index);
  }

  function zustandZeichnen(liste, index) {
    /* Pfeile: am Rand abschalten statt umlaufen. Begruendung im Bericht —
       ein Umlauf verschleiert, wo die Reihe endet, und die Thumbnail-Leiste
       zeigt die Grenzen ohnehin sichtbar an. */
    if (z.zurueck) z.zurueck.disabled = index <= 0;
    if (z.vor) z.vor.disabled = index >= liste.length - 1;
    z.anzahl = liste.length;

    var knoepfe = z.leiste ? z.leiste.children : [];
    for (var i = 0; i < knoepfe.length; i++) {
      var an = i === index;
      knoepfe[i].setAttribute('aria-current', an ? 'true' : 'false');
      if (an && z.leiste.scrollWidth > z.leiste.clientWidth) {
        var b = knoepfe[i];
        var links = b.offsetLeft - (z.leiste.clientWidth - b.offsetWidth) / 2;
        z.leiste.scrollTo({ left: links, behavior: 'smooth' });
      }
    }
    z.index = index;
    z.letzteId = liste[index] ? liste[index].getAttribute('data-media-id') : null;
  }

  /**
   * Thumbnail-Leiste aus den sichtbaren Modal-Kindern herstellen.
   * Wiederholbar: Es wird immer vollstaendig neu befuellt, mehrfaches
   * Ausfuehren mit demselben Zustand fuehrt zum selben Ergebnis.
   */
  function leisteAufbauen() {
    if (!z.leiste) return;
    var liste = medien(z.modal);
    z.leiste.textContent = '';

    liste.forEach(function (el, i) {
      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'galerie-lb-thumb';
      knopf.setAttribute('aria-current', 'false');

      var bild = document.createElement('img');
      /* Aus dem Buehnenbild ableiten statt neu zu laden: dieselbe Quelle,
         also kein zusaetzlicher Abruf. Bei Video und 3D-Modell gibt es kein
         <img> — dann bleibt der Knopf leer, aber bedienbar. */
      var quelle = el.tagName === 'IMG' ? el : el.querySelector('img');
      if (quelle) {
        bild.src = quelle.currentSrc || quelle.src;
        bild.alt = quelle.alt || '';
      } else {
        bild.alt = '';
      }
      bild.loading = 'lazy';
      knopf.appendChild(bild);

      /* Video: Standbild (Dawns Vorschaubild, oben schon uebernommen) plus
         kleines Play-Symbol, damit man es in der Leiste erkennt. */
      if (videoVorlage(el)) {
        knopf.classList.add('galerie-lb-thumb--video');
        if (z.playSymbol) knopf.appendChild(z.playSymbol.cloneNode(true));
      }

      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        zeigen(i);
      });
      klickSchuetzen(knopf);

      z.leiste.appendChild(knopf);
    });

    /* Passen alle nebeneinander, mittig stellen — sonst links beginnen. */
    z.leiste.classList.remove('galerie-lb-leiste--kompakt');
    if (z.leiste.scrollWidth <= z.leiste.clientWidth) {
      z.leiste.classList.add('galerie-lb-leiste--kompakt');
    }

    zustandZeichnen(liste, aktiverIndex(liste));
    log('Leiste aufgebaut:', liste.length, 'Thumbnails');
  }

  /* =========================================================================
   * Flaeche neben dem Medium (Desktop)
   * ======================================================================= */

  /**
   * -1 = zurueck, 1 = weiter, 0 = nichts.
   *
   * "Neben dem Medium" heisst: Der Zeiger steht auf der Buehne selbst, nicht
   * auf Bild oder Video. Beim Video ist die Dawn-Huelle buehnengross, ihre
   * freie Flaeche zaehlt deshalb mit; das <video> selbst nicht. Geteilt wird
   * an der Buehnenmitte. Am Rand der Reihe gibt es nichts zu blaettern.
   */
  function flaechenRichtung(e, inhalt) {
    if (!z || !FEINER_ZEIGER.matches) return 0;
    var aktiv = aktivesMedium();
    var frei = e.target === inhalt || (aktiv && aktiv.tagName === 'DEFERRED-MEDIA' && e.target === aktiv);
    if (!frei) return 0;
    var r = inhalt.getBoundingClientRect();
    var richtung = e.clientX < r.left + r.width / 2 ? -1 : 1;
    var ziel = z.index + richtung;
    return ziel >= 0 && ziel < z.anzahl ? richtung : 0;
  }

  /* =========================================================================
   * Fokus
   * ======================================================================= */

  function fokussierbare() {
    var kandidaten = z.dialog.querySelectorAll(
      'button:not([disabled]), [href], [tabindex]:not([tabindex="-1"]), video[controls]'
    );
    return Array.prototype.filter.call(kandidaten, function (el) {
      return el.getClientRects().length > 0;
    });
  }

  /** Tab am Ende springt an den Anfang und umgekehrt — jedes Mal neu gezaehlt. */
  function fokusFalle(e) {
    var f = fokussierbare();
    if (!f.length) return;
    var erst = f[0];
    var letzt = f[f.length - 1];
    var akt = document.activeElement;
    var draussen = !z.dialog.contains(akt) || akt === z.dialog;
    if (!e.shiftKey && (akt === letzt || draussen)) {
      e.preventDefault();
      e.stopPropagation();
      erst.focus();
    } else if (e.shiftKey && (akt === erst || draussen)) {
      e.preventDefault();
      e.stopPropagation();
      letzt.focus();
    }
  }

  /* =========================================================================
   * Browser-Zurueck
   * ======================================================================= */

  /** Beim Oeffnen: eigener Eintrag mit derselben Adresse. */
  function historieSetzen() {
    if (z.historie) return;
    var zustand = {};
    zustand[HISTORIE_MARKE] = true;
    history.pushState(zustand, '');
    z.historie = true;
  }

  /**
   * Beim Schliessen per X oder Escape: den eigenen Eintrag wieder
   * herausnehmen. Nur wenn er noch obenauf liegt — ersetzt ihn etwas
   * anderes (Dawn schreibt bei einem Variantenwechsel per replaceState),
   * bleibt die Historie, wie sie ist, statt einen fremden Eintrag zu
   * entfernen.
   */
  function historieAufraeumen() {
    if (!z.historie) return;
    z.historie = false;
    if (history.state && history.state[HISTORIE_MARKE]) history.back();
  }

  /** Browser-Zurueck bei offener Lightbox: nur schliessen. */
  function zurueckGedrueckt() {
    if (!z || !z.historie) return;
    /* Der eigene Eintrag ist bereits weg — nichts mehr aufzuraeumen. */
    z.historie = false;
    if (z.modal.hasAttribute('open')) z.modal.hide();
  }

  /* =========================================================================
   * Aufbau
   * ======================================================================= */

  function einrichten() {
    var modal = document.querySelector('product-modal.product-media-modal');
    var vorlage = document.querySelector('[data-galerie-lightbox-vorlage]');
    if (!modal || !vorlage) return false;

    var dialog = modal.querySelector('.product-media-modal__dialog');
    if (!dialog) return false;
    if (dialog.querySelector('[data-galerie-lb="leiste"]')) return true; /* schon eingerichtet */

    dialog.appendChild(vorlage.content.cloneNode(true));

    z = {
      modal: modal,
      dialog: dialog,
      zurueck: dialog.querySelector('[data-galerie-lb="zurueck"]'),
      vor: dialog.querySelector('[data-galerie-lb="vor"]'),
      leiste: dialog.querySelector('[data-galerie-lb="leiste"]'),
      playSymbol: dialog.querySelector('[data-galerie-lb="play-symbol"]'),
      index: 0,
      anzahl: 0,
      historie: false
    };
    /* Das Play-Symbol ist nur Kopiervorlage fuer die Leiste. */
    if (z.playSymbol) z.playSymbol.remove();

    /* Schliessen per Klick abschalten. Dawn schliesst bei jedem Maus-
       pointerup im Modal (Falle 1). Am Dialog abgefangen erreicht kein
       pointerup aus dem Inneren mehr das Modal. Liegt der Klick auf dem Modal
       selbst (ausserhalb des Dialogs), faengt die Einfangphase ihn ab —
       stopImmediatePropagation, weil Dawns Zuhoerer am selben Element haengt. */
    dialog.addEventListener('pointerup', function (e) {
      e.stopPropagation();
    });
    modal.addEventListener('pointerup', function (e) {
      if (e.target === modal) e.stopImmediatePropagation();
    }, true);

    [z.zurueck, z.vor].forEach(function (b) {
      if (!b) return;
      klickSchuetzen(b);
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        zeigen(z.index + (b === z.vor ? 1 : -1));
      });
    });
    if (z.leiste) klickSchuetzen(z.leiste);

    /* Tastatur. Escape erledigt Dawn bereits (keyup am Modal, gemessen).
       Die Pfeiltasten blaettern auch, wenn das Video den Fokus hat — dort
       spulten sie sonst; der Auftrag will Blaettern. */
    modal.addEventListener('keydown', function (e) {
      if (!modal.hasAttribute('open')) return;
      if (e.code === 'ArrowRight') { e.preventDefault(); zeigen(z.index + 1); }
      else if (e.code === 'ArrowLeft') { e.preventDefault(); zeigen(z.index - 1); }
      else if (e.key === 'Tab') fokusFalle(e);
    });

    /* Faellt der Fokus doch hinaus (z. B. Klick in die Adresszeile und
       zurueck), holt ihn das zurueck in den Dialog. */
    document.addEventListener('focusin', function (e) {
      if (!z || z.modal !== modal || !modal.hasAttribute('open')) return;
      if (modal.contains(e.target)) return;
      var f = fokussierbare();
      if (f.length) f[0].focus();
    });

    var inhalt = modal.querySelector('.product-media-modal__content');

    /* Blaettern ueber die Flaeche neben dem Medium (nur Maus). Der Zustand
       steht am Dialog, das Stylesheet zeigt daran Zeiger und Pfeil-Hover. */
    if (inhalt) {
      inhalt.addEventListener('mousemove', function (e) {
        var r = flaechenRichtung(e, inhalt);
        dialog.setAttribute('data-galerie-lb-zeigt', r < 0 ? 'zurueck' : r > 0 ? 'vor' : '');
      });
      inhalt.addEventListener('mouseleave', function () {
        dialog.setAttribute('data-galerie-lb-zeigt', '');
      });
      inhalt.addEventListener('click', function (e) {
        var r = flaechenRichtung(e, inhalt);
        if (!r) return;
        e.preventDefault();
        zeigen(z.index + r);
        /* Nach dem Wechsel steht die Maus evtl. ueber dem neuen Medium. */
        var neu = flaechenRichtung(e, inhalt);
        dialog.setAttribute('data-galerie-lb-zeigt', neu < 0 ? 'zurueck' : neu > 0 ? 'vor' : '');
      });
    }

    /* Wischen auf der Buehne. */
    if (inhalt) {
      var start = null;
      inhalt.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        /* Beginnt die Beruehrung auf der Steuerleiste eines Videos, ist das
           Spulen oder Lautstaerke — kein Blaettern. */
        var video = e.target.closest ? e.target.closest('video') : null;
        if (video && t.clientY > video.getBoundingClientRect().bottom - VIDEO_STEUERLEISTE_PX) {
          start = null;
          return;
        }
        start = { x: t.clientX, y: t.clientY };
      }, { passive: true });
      inhalt.addEventListener('touchend', function (e) {
        if (!start) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - start.x;
        var dy = t.clientY - start.y;
        start = null;
        /* Nur waagerechte Gesten, und deutlich waagerechter als senkrecht. */
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        zeigen(z.index + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    /* Dawn ersetzt bei jedem Variantenwechsel den Inhalt per innerHTML
       (assets/product-info.js). Die Leiste liegt zwar ausserhalb und
       ueberlebt, ihre Thumbnails zeigen danach aber die alte Menge — und die
       Klasse "active" ist weg, weil sie am ersetzten Markup hing.

       Im Staging nachgestellt (Lightbox offen, Wechsel auf "Kletterseil"):
       35 Thumbnails statt 21 und eine LEERE Buehne (kein .active, 0 gemalt).

       Zwei Ursachen, zwei Gegenmassnahmen:
         1. showActiveMedia laeuft nur beim Oeffnen -> hier selbst aktivieren
         2. Rubik filtert erst ~100-300 ms spaeter -> zweiter Durchgang, wenn
            Etappe 0 den eingependelten Zustand meldet */
    if (inhalt && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        leisteAufbauen();
        aktivSicherstellen();
      }).observe(inhalt, { childList: true });
    }

    /* Beim Oeffnen: Dawn hat die Buehne ueber openedBy schon gesetzt, wir
       ziehen Leiste und Pfeile nach. Beim Schliessen: Position uebernehmen. */
    new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        leisteAufbauen();
        videoVorbereiten(aktivesMedium());
        historieSetzen();
      } else {
        dialog.setAttribute('data-galerie-lb-zeigt', '');
        videosAnhalten();
        positionUebernehmen();
        historieAufraeumen();
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    log('eingerichtet');
    return true;
  }

  /**
   * Beim Schliessen den Slider darunter auf dasselbe Bild stellen.
   *
   * Bewusst ueber die Scrollposition und nicht ueber setActiveMedia: Etappe 3
   * haengt an Dawns slideChanged, das nur beim Scrollen feuert. Ein Sprung
   * ueber scrollTo loest es aus, die Strichanzeige folgt dadurch von selbst.
   */
  function positionUebernehmen() {
    try {
      var aktiv = aktivesMedium();
      if (!aktiv) return;
      var id = aktiv.getAttribute('data-media-id');
      if (!id) return;

      var ul = document.querySelector('media-gallery ul.product__media-list');
      if (!ul) return;
      var sichtbare = Array.prototype.filter.call(
        ul.querySelectorAll('li[data-media-id]'),
        function (li) {
          return li.clientWidth > 0;
        }
      );
      var ziel = null;
      for (var i = 0; i < sichtbare.length; i++) {
        /* Im Modal steht die nackte Media-ID, in der Galerie das Format
           "<section>-<id>". Deshalb Endvergleich statt Gleichheit. */
        var mid = sichtbare[i].getAttribute('data-media-id') || '';
        if (mid === id || mid.slice(-(id.length + 1)) === '-' + id) {
          ziel = sichtbare[i];
          break;
        }
      }
      if (!ziel || !sichtbare.length) return;
      ul.scrollTo({ left: ziel.offsetLeft - sichtbare[0].offsetLeft, behavior: 'instant' });
      log('Position uebernommen:', id);
    } catch (fehler) {
      log('Position konnte nicht uebernommen werden', fehler);
    }
  }

  /* =========================================================================
   * Knopf "weitere Bilder"
   * ======================================================================= */

  function knopfVerdrahten() {
    var knopf = document.querySelector('.galerie-mehr');
    if (!knopf || knopf.dataset.galerieLbBereit) return;
    knopf.dataset.galerieLbBereit = '1';

    knopf.addEventListener('click', function (e) {
      e.preventDefault();
      var modal = document.querySelector('product-modal.product-media-modal');
      if (!modal) return;
      var liste = medien(modal);
      if (!liste.length) return;
      /* product-modal.js liest die ID vom ausloesenden Element. */
      knopf.setAttribute('data-media-id', liste[0].getAttribute('data-media-id'));
      modal.show(knopf);
    });

    /* Erst jetzt bedienbar machen — faellt das Skript aus, bleibt der Knopf
       ehrlich als nicht verfuegbar angekuendigt statt tot zu wirken. */
    knopf.removeAttribute('disabled');
  }

  /* =========================================================================
   * Tap gegen Wischen auf der Hauptgalerie
   * ======================================================================= */

  function tapTrennen() {
    var ul = document.querySelector('media-gallery ul.product__media-list');
    if (!ul || ul.dataset.galerieTapBereit) return;
    ul.dataset.galerieTapBereit = '1';

    var geste = null;

    ul.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      geste = { x: t.clientX, y: t.clientY, zeit: Date.now(), scroll: ul.scrollLeft, wisch: false };
    }, { passive: true });

    ul.addEventListener('touchmove', function (e) {
      if (!geste) return;
      var t = e.changedTouches[0];
      if (
        Math.abs(t.clientX - geste.x) > TAP_WEG_PX ||
        Math.abs(t.clientY - geste.y) > TAP_WEG_PX ||
        Math.abs(ul.scrollLeft - geste.scroll) > TAP_SCROLL_PX
      ) {
        geste.wisch = true;
      }
    }, { passive: true });

    /* Capture am Vorfahren: Dawns ModalOpener haengt am <button> darunter.
       Wird die Weitergabe hier gestoppt, erreicht der Klick ihn nie.
       Dasselbe Muster wie beim Takelfarben-Picker (siehe THEME-ANPASSUNGEN). */
    ul.addEventListener(
      'click',
      function (e) {
        if (!geste) return;
        var zuLang = Date.now() - geste.zeit > TAP_DAUER_MS;
        var gescrollt = Math.abs(ul.scrollLeft - geste.scroll) > TAP_SCROLL_PX;
        var wisch = geste.wisch || zuLang || gescrollt;
        geste = null;
        if (!wisch) return;
        e.stopPropagation();
        e.preventDefault();
        log('Wischen erkannt, Lightbox nicht geoeffnet');
      },
      true
    );
  }

  /* =========================================================================
   * Start
   * ======================================================================= */

  function start() {
    try {
      if (!document.querySelector('[data-galerie-lightbox-vorlage]')) return;

      /* Dawn verschiebt das Modal erst im connectedCallback an <body>. Kommt
         es hier noch nicht vor, kurz erneut versuchen. */
      var versuche = 0;
      var anlauf = function () {
        if (einrichten()) {
          knopfVerdrahten();
          tapTrennen();
          return;
        }
        if (++versuche < 20) window.setTimeout(anlauf, 50);
      };
      anlauf();

      window.addEventListener('popstate', zurueckGedrueckt);

      /* Rubik filtert die Modal-Kinder erst nach dem Inhaltsaustausch. Etappe 0
         meldet genau dann, wenn sich alles eingependelt hat — das ist der
         richtige Zeitpunkt fuer den zweiten Durchgang. Ohne ihn zeigte die
         Leiste kurzzeitig die ungefilterte Menge (im Staging gemessen: 35
         statt 21 Thumbnails). */
      document.addEventListener('isartau:galerie-eingependelt', function () {
        try {
          if (!z) return;
          leisteAufbauen();
          aktivSicherstellen();
        } catch (fehler) {
          log('Nachziehen nach Meldung fehlgeschlagen', fehler);
        }
      });

      /* Nach einem Produktwechsel ueber Dawns Austauschpfad sind Galerie,
         Knopf und Modal neu. */
      document.addEventListener('product-info:loaded', function () {
        z = null;
        window.setTimeout(function () {
          einrichten();
          knopfVerdrahten();
          tapTrennen();
        }, 0);
      });
    } catch (fehler) {
      log('Start fehlgeschlagen', fehler);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
